// extracted by mini-css-extract-plugin
export default {"headerComponent":"PlayersAndStaffList_headerComponent__3W4Ib"};